import uaaApi from "../../../api/uaaConfig";

export const getFeatureByProduct = (params) => {
  return uaaApi({
    method: "get",
    url: "/api/v1/feature/list-by-product",
    params,
  });
};

export const getApiByProduct = (params) => {
  return uaaApi({
    method: "get",
    url: "/api/v1/api/list-by-role",
    params,
  });
};

export const createUpdateRole = (data, method) => {
  return uaaApi({
    method,
    url: "/api/v1/role",
    data,
  });
};

export const getRoleDetail = (params) => {
  return uaaApi({
    method: "get",
    url: "/api/v1/role",
    params,
  });
};

export const modifyApiRole = (params) => {
  return uaaApi({ method: "put", url: "/api/v1/role/modify-api", params });
};
